<template>
  <div class="right_col" role="main">
    <div class="row">
      <div class="col-md-4">
        <div class="x_panel">
          <div class="x_content">
            <div class="row">
              <div class="col-md-12 col-sm-6 col-xs-12">
                <div class="title_left">
                  <h3>地標</h3>
                  <hr />
                </div>
              </div>
            </div>
            <div class="row">
              <h4 class="fontSize16">
                目前數量：
                <span>
                  {{
                    vx_paging && vx_paging.totalEntries != null
                      ? vx_paging.totalEntries
                      : 0
                  }}
                </span>
              </h4>
            </div>
            <div class="row blockmargin">
              <label class="fontSize16 col-md-3 col-sm-3 col-xs-3">
                地標名稱
              </label>
              <input
                type="text"
                class="inputstyle fontSize16 col-md-9 col-sm-9 col-xs-9"
                v-model="markerInfo.name"
              />
            </div>
            <div class="row blockmargin">
              <label class="fontSize16 col-md-3 col-sm-3 col-xs-3">
                地標地址
              </label>
              <textarea
                type="text"
                class="inputstyle fontSize16 col-md-9 col-sm-9 col-xs-9"
                v-model="markerInfo.address"
                rows="3"
              ></textarea>
            </div>
            <div class="row blockmargin">
              <label class="fontSize16 col-md-3 col-sm-3 col-xs-3">
                地標備註
              </label>
              <textarea
                type="text"
                class="inputstyle fontSize16 col-md-9 col-sm-9 col-xs-9"
                v-model="markerInfo.note"
                rows="2"
              ></textarea>
            </div>
            <div class="row blockmargin">
              <label class="fontSize16 col-md-3 col-sm-3 col-xs-3">
                經緯度
              </label>
              <input
                type="text"
                class="inputstyle fontSize16 col-md-9 col-sm-9 col-xs-9"
                v-model="markerInfo.gps"
                disabled
              />
            </div>
            <div class="row blockmargin">
              <label class="fontSize16 col-md-4 col-sm-4 col-xs-4">
                資料更新人員
              </label>
              <input
                type="text"
                class="inputstyle fontSize16 col-md-8 col-sm-8 col-xs-8"
                v-model="markerInfo.serviceName"
                disabled
              />
            </div>
            <div class="row blockmargin">
              <label class="fontSize16 col-md-4 col-sm-4 col-xs-4">
                前次更新時間
              </label>
              <input
                type="text"
                class="inputstyle fontSize16 col-md-8 col-sm-8 col-xs-8"
                v-model="markerInfo.updatedAt"
                disabled
              />
            </div>
            <div class="row">
              <button
                class="btn btn-success fontSize16"
                v-show="!markerInfo.isOldOne"
                @click="onAddLandmark"
              >
                新增
              </button>
              <button
                class="btn btn-dark fontSize16"
                v-show="markerInfo.isOldOne"
                @click="onUpdateLandmark"
              >
                更新
              </button>
              <button
                class="btn btn-danger fontSize16"
                v-show="markerInfo.isOldOne"
                @click="onDeleteLandmark"
              >
                刪除
              </button>
              <button class="btn btn-default fontSize16" @click="clearLandmark">
                清除
              </button>
            </div>
          </div>
        </div>
        <div class="row">
          <AddrAutoComplete
            v-model="autoInputAddr"
            @getSelectedAddr="getSelectedAddr"
            :row="2"
            class="col-md-12"
          />
        </div>
        <div class="row" style="margin-top: 70px; margin-left: 250px">
          <button class="btn btn-dark fontSize16" @click="setLocationOnMap">
            搜尋
          </button>
          <button
            class="btn btn-default fontSize16"
            @click="setAddrToMarkerInfo"
          >
            輸入地址
          </button>
        </div>
      </div>
      <div class="col-md-8">
        <div class="x_panel">
          <div class="x_content">
            <div class="" role="tabpanel" data-example-id="togglable-tabs">
              <ul id="myTab" class="nav nav-tabs bar_tabs" role="tablist">
                <li role="presentation" class="active fontSize16">
                  <a
                    href="#tab_content1"
                    id="home-tab"
                    role="tab"
                    data-toggle="tab"
                    aria-expanded="true"
                  >
                    地圖
                  </a>
                </li>
                <li role="presentation" class="fontSize16">
                  <a
                    href="#tab_content2"
                    role="tab"
                    id="profile-tab"
                    data-toggle="tab"
                    aria-expanded="false"
                  >
                    列表
                  </a>
                </li>
              </ul>
              <div id="myTabContent" class="tab-content">
                <div
                  role="tabpanel"
                  class="tab-pane fade active in"
                  id="tab_content1"
                  aria-labelledby="home-tab"
                >
                  <google-map
                    name="example"
                    ref="mapMarker"
                    class="col-md-12 col-sm-12"
                    style="height: 600px"
                    :input-latitude="searchLocation.latitude"
                    :input-longitude="searchLocation.longitude"
                    :size="10"
                    @landmarkInfo="setLandMarkInfo"
                    @deliveryGPSData="listenGPSFromMap"
                  />
                </div>
                <div
                  role="tabpanel"
                  class="tab-pane fade in"
                  id="tab_content2"
                  aria-labelledby="home-tab"
                >
                  <input
                    type="text"
                    class="inputstyle col-md-6 fontSize16"
                    v-model="landmarkKeyword"
                    placeholder="名稱、地點"
                  />
                  <button
                    class="btn btn-dark fontSize16"
                    @click="onSearchLandmark"
                  >
                    搜尋
                  </button>
                  <landmark-list
                    @setLandmarkInfoFromList="setLandmarkInfoFromList"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  reqAddLandmark,
  reqUpdateLandmark,
  reqDeleteLandmark,
} from '@/api/landmark'
import { mapActions, mapState, mapMutations } from 'vuex'
import { Notification } from 'element-ui'
import { cookies } from '@/utils/cookies'
import GoogleMap from '../mapComponent/LandmarkMap.vue'
import LandmarkList from './LandmarkList.vue'
/* import CountrySelect from '@/components/tool/CountrySelect' */
import AddrAutoComplete from '@/components/tool/AddrAutoComplete'
import BehaviorRecorder from '@/assets/js/libs/BehaviorRecorder'

export default {
  components: {
    GoogleMap,
    LandmarkList,
    /* CountrySelect, */
    AddrAutoComplete,
  },
  data() {
    return {
      searchLocation: {
        latitude: null,
        longitude: null,
        address: null,
      },
      markerInfo: {
        landmarkID: '',
        name: '',
        address: '',
        gps: '',
        note: '',
        latGps: '',
        lngGps: '',
        serviceName: '',
        updatedAt: '',
        isOldOne: false,
        isConfirmed: false,
      },
      autoLocation: {
        latitude: null,
        longitude: null,
        address: null,
      },
      autoInputAddr: '',
      landmarkKeyword: '',
    }
  },
  methods: {
    ...mapActions('landmark', {
      vx_fetchLandmarkList: 'fetchLandmarkList',
    }),
    ...mapMutations('landmark', {
      vx_setLandmarkKeyword: 'setLandmarkKeyword',
    }),
    getSelectedAddr({ longitude, latitude }) {
      this.autoLocation = {
        latitude: latitude,
        longitude: longitude,
        address: this.autoInputAddr,
      }
    },
    setLocationOnMap() {
      this.$refs.mapMarker.setMarker({
        lat: this.autoLocation.latitude,
        lng: this.autoLocation.longitude,
      })
    },
    setAddrToMarkerInfo() {
      this.markerInfo.address = this.autoLocation.address
      this.markerInfo.gps =
        this.autoLocation.latitude + ',' + this.autoLocation.longitude
      this.markerInfo.latGps = this.autoLocation.latitude
      this.markerInfo.lngGps = this.autoLocation.longitude
    },
    setLandmarkInfoFromList(landmarkInfo) {
      this.markerInfo = landmarkInfo
      this.$refs.mapMarker.setMarker({
        lat: landmarkInfo.latGps,
        lng: landmarkInfo.lngGps,
      })
    },
    setLandMarkInfo(m) {
      this.markerInfo = {
        landmarkID: m.landmarkID,
        name: m.name,
        address: m.address,
        note: m.note,
        gps: m.addressGPS.coordinates,
        latGps: m.addressGPS.coordinates[1],
        lngGps: m.addressGPS.coordinates[0],
        isOldOne: m.showCreate,
        serviceName: m.serviceName,
        updatedAt: m.updatedAt,
      }
    },
    onCancelEditMapBtnClick() {
      this.$refs.childMethod.clearData()
    },
    listenGPSFromMap(m) {
      this.markerInfo.address = m.formatted_address
      this.markerInfo.latGps = m.geometry.location.lat()
      this.markerInfo.lngGps = m.geometry.location.lng()
      this.markerInfo.gps =
        m.geometry.location.lat() + ',' + m.geometry.location.lng()
    },
    onSearchLandmark() {
      this.vx_setLandmarkKeyword(this.landmarkKeyword)
      this.vx_fetchLandmarkList({ currentPage: 1, kw: this.landmarkKeyword })
    },
    async onAddLandmark() {
      /* 表單校驗 */
      if (!this.markerInfo.address) {
        Notification({ type: 'warning', message: '請選擇地點' })
        return
      }
      if (!this.markerInfo.name) {
        Notification({ type: 'warning', message: '請填入名稱' })
        return
      }
      try {
        BehaviorRecorder.record('點擊', '地標編輯', '新增地標')
        const res = await reqAddLandmark({
          name: this.markerInfo.name,
          note: this.markerInfo.note,
          address: this.markerInfo.address,
          latGps: this.markerInfo.latGps,
          lngGps: this.markerInfo.lngGps,
          specialContract: '',
        })
        if (res.result) {
          /* 將地圖的中心座標訂在剛新增的marker上 */
          this.$refs.mapMarker.setFouceMarker(
            this.markerInfo.latGps,
            this.markerInfo.lngGps,
          )
          this.clearLandmark()
          this.getMarkerList()
          this.autoInputAddr = ''
          Notification({ type: 'success', message: '新增成功' })
        }
        if (res.err) {
          Notification({
            type: 'error',
            message: '請輸入名稱或是地標地址或經緯度',
          })
        }
      } catch (e) {
        Notification({ type: 'error', message: '新增失敗' })
        console.error(e)
      }
    },
    async onUpdateLandmark() {
      try {
        BehaviorRecorder.record('點擊', '地標編輯', '更新地標')
        const res = await reqUpdateLandmark(this.markerInfo.landmarkID, {
          name: this.markerInfo.name,
          note: this.markerInfo.note,
          address: this.markerInfo.address,
          latGps: this.markerInfo.latGps,
          lngGps: this.markerInfo.lngGps,
          specialContract: '',
        })
        if (res.result) {
          this.clearLandmark()
          this.$refs.mapMarker.clearMarkerMutiple()
          this.getMarkerList()
          this.markerInfo.isOldOne = false
          Notification({ type: 'success', message: '更新成功' })
        } else if (res.err === '請在body中輸入address') {
          Notification({ type: 'error', message: '更新失敗:輸入地址' })
        } else if (res.err === '請在body中輸入name') {
          Notification({ type: 'error', message: '更新失敗:輸入名稱' })
        }
      } catch (e) {
        Notification({ type: 'error', message: '更新失敗' })
        console.error(e)
      }
    },
    async onDeleteLandmark() {
      try {
        const res = await reqDeleteLandmark(this.markerInfo.landmarkID)
        if (res.result) {
          this.$refs.mapMarker.clearMarkerMutiple()
          this.getMarkerList()
          this.clearLandmark()
          Notification({ type: 'success', message: '刪除成功' })
        } else {
          Notification({ type: 'error', message: '刪除失敗' })
        }
      } catch (e) {
        Notification({ type: 'error', message: '刪除失敗' })
        console.error(e)
      }
    },
    getMarkerList(currentPage = 1) {
      try {
        this.vx_fetchLandmarkList({ page: currentPage })
      } catch (e) {
        Notification({ type: 'error', message: '提取自建地標列表失敗' })
        console.error(e)
      }
    },
    clearLandmark() {
      this.markerInfo = {
        landmarkID: '',
        name: '',
        address: '',
        gps: '',
        note: '',
        latGps: '',
        lngGps: '',
        serviceName: '',
        updatedAt: '',
        isOldOne: false,
        isConfirmed: false,
      }
      this.$refs.mapMarker.clearSelfLandmarkData()
    },
  },
  computed: {
    ...mapState('landmark', {
      vx_paging: 'paging',
    }),
    showCreate: function () {
      return this.markerInfo.gps === ''
    },
  },
  mounted() {
    this.getMarkerList()
    this.autoInputAddr = cookies.get('GladArea')
  },
}
</script>



// WEBPACK FOOTER //
// src/pages/landmark/LandmarkEdit.vue